import Exports from "../components/exports/Exports"

const ExportsPage = () => {
     return <Exports />
}

export default ExportsPage